import { Text } from '@/components/core';

export const BetaBadge = () => {
  return (
    <div className="bg-primary-25 flex items-center rounded-xs px-1">
      <Text size="xs" className="!text-primary-500 !font-medium">
        Beta
      </Text>
    </div>
  );
};
